"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var CornerDownRight = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "corner-down-right" },
            react_1.default.createElement("path", { id: "Icon", d: "M5 4C5 3.44772 4.55228 3 4 3C3.44772 3 3 3.44772 3 4H5ZM20 15L20.7071 15.7071C21.0976 15.3166 21.0976 14.6834 20.7071 14.2929L20 15ZM4.65396 11.7239L3.76295 12.1779L4.65396 11.7239ZM7.27606 14.346L7.73005 13.455H7.73005L7.27606 14.346ZM15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289C13.9024 9.68342 13.9024 10.3166 14.2929 10.7071L15.7071 9.29289ZM14.2929 19.2929C13.9024 19.6834 13.9024 20.3166 14.2929 20.7071C14.6834 21.0976 15.3166 21.0976 15.7071 20.7071L14.2929 19.2929ZM3 4V5.4H5V4H3ZM13.6 16H20V14H13.6V16ZM3 5.4C3 7.06366 2.99922 8.37154 3.08507 9.42222C3.17186 10.4846 3.35217 11.3717 3.76295 12.1779L5.54497 11.27C5.30179 10.7927 5.15512 10.198 5.07842 9.25936C5.00078 8.30901 5 7.09666 5 5.4H3ZM13.6 14C11.9033 14 10.691 13.9992 9.74064 13.9216C8.80197 13.8449 8.20731 13.6982 7.73005 13.455L6.82207 15.237C7.62827 15.6478 8.51543 15.8281 9.57778 15.9149C10.6285 16.0008 11.9363 16 13.6 16V14ZM3.76295 12.1779C4.43407 13.4951 5.50493 14.5659 6.82207 15.237L7.73005 13.455C6.78924 12.9757 6.02433 12.2108 5.54497 11.27L3.76295 12.1779ZM14.2929 10.7071L19.2929 15.7071L20.7071 14.2929L15.7071 9.29289L14.2929 10.7071ZM19.2929 14.2929L14.2929 19.2929L15.7071 20.7071L20.7071 15.7071L19.2929 14.2929Z" }))));
};
exports.default = CornerDownRight;
